import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
	margin: 8px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-items: center;
	background-color: white;
`;
const Image = styled.div`
	position: relative;
	background-repeat: no-repeat;
	background-size: cover;
	cursor: pointer;
	justify-self: center;
	margin: 0 auto 8px;
`;
const Label = styled.p`
	display: block;
	text-align: center;
	word-break: break-word;
	font-size: 14px;
	user-select: none;
`;

const ImageItem = props => {
	let aspect = Math.round(props.aspect * 1000) / 1000;
	const url = props.conversions.min;
	const width = aspect > 1 ? '50%' : '100%';
	const name = props.name
		.replace(/_/g, ' ')
		.replace(/\(\d\)/g, '')
		.replace(/\.jpg|jpeg|png|bmp/gi, '');

	if (aspect > 1) {
		aspect = aspect / 2;
	}

	const paddingBottom = aspect * 100;

	const style = {
		backgroundImage: `url(${url})`,
		width,
		paddingBottom: `${paddingBottom}%`
	};

	if (props.fitImage) {
		style.backgroundSize = 'contain';
		style.backgroundPosition = 'center';
	}

	return (
		<Container>
			<Image style={style} />
			<Label>{ name }</Label>
		</Container>
	)
}

ImageItem.propTypes = {
	aspect: PropTypes.any,
	conversions: PropTypes.object,
	name: PropTypes.string,
}

export default ImageItem;
